import { useRestaurant } from "../../hooks/RestaurantContext";

export const useHasValidRestaurant = () => {
  const { restaurantId } = useRestaurant();
  return restaurantId && restaurantId !== "";
};
